(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-app-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-th-app]').forEach(function (sec) {
      if (!('IntersectionObserver' in window) || reduce) { sec.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.2 });
      io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-benchmark"] && !Shopify.designMode) return;
  try {
    
(function () {
  function countUp(el) {
    var target = parseFloat(el.dataset.countup);
    var suffix = el.dataset.suffix || '';
    if (isNaN(target)) return;
    var dur = 1300, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.innerHTML = Math.round(eased * target) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-th-bm]').forEach(function (sec) {
      if (!('IntersectionObserver' in window) || reduce) {
        sec.classList.add('is-in');
        sec.querySelectorAll('[data-countup]').forEach(function (el) { el.innerHTML = Math.round(parseFloat(el.dataset.countup)) + (el.dataset.suffix || ''); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            sec.classList.add('is-in');
            sec.querySelectorAll('[data-countup]').forEach(countUp);
            io.unobserve(sec);
          }
        });
      }, { threshold: 0.3 });
      io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-book"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-th-book]').forEach(function (sec) {
      if (!('IntersectionObserver' in window) || reduce) { sec.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(sec); } });
      }, { threshold: 0.25 });
      io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-collection-grid"] && !Shopify.designMode) return;
  try {
    
/**
 * th-collection-filters — client-seitige Facetten-Chips fuer das Collection-Grid.
 * Progressive enhancement: ohne JS bleibt das ungefilterte Grid mit Pagination.
 * Achsen werden aus den Produktkarten abgeleitet (Titel -> Bundesland/Bereich,
 * data-th-price -> Preis). Bei paginierten Collections werden die Restseiten
 * on demand ueber die Section Rendering API nachgeladen, damit die Filter ueber
 * die gesamte Collection wirken. OR innerhalb einer Achse, AND zwischen Achsen.
 */
class ThCollectionFilters extends HTMLElement {
  connectedCallback() {
    this._root = this.closest('.th-collection-grid');
    this._list = this._root && this._root.querySelector('.th-collection-grid__list');
    if (!this._list) return;

    this._countEl = this._root.querySelector('.th-collection-grid__count');
    this._pagEl = this._root.querySelector('[data-th-pagination]');
    this._emptyEl = this._root.querySelector('[data-th-filter-empty]');
    this._origCount = this._countEl ? this._countEl.textContent.trim() : '';
    this._pages = parseInt(this.dataset.pages || '1', 10) || 1;
    this._currentPage = parseInt(this.dataset.currentPage || '1', 10) || 1;
    this._total = parseInt(this.dataset.productsCount || '0', 10) || 0;
    this._loaded = this._pages <= 1;
    this._loadFailed = false;
    this._loadPromise = null;
    this._active = {};

    this._axes = this._buildAxes();

    for (const [i, li] of this._cards().entries()) {
      li.setAttribute('data-th-page', String(this._currentPage));
      li.setAttribute('data-th-idx', String(i));
    }

    this._render();
    this.removeAttribute('data-th-pending');

    if (this._pages > 1) {
      if (this._pages <= 3) {
        setTimeout(() => { this._ensureLoaded(); }, 1500);
      } else {
        const once = () => { this._ensureLoaded(); };
        this.addEventListener('pointerenter', once, { once: true });
        this.addEventListener('focusin', once, { once: true });
        this.addEventListener('touchstart', once, { once: true, passive: true });
      }
    }

    const resetAll = this._root.querySelector('[data-th-filter-reset-all]');
    if (resetAll) resetAll.addEventListener('click', () => this._reset());
  }

  _buildAxes() {
    const land = [
      ['Baden-Württemberg', /baden-w(ü|ue)rttemberg/i],
      ['Bayern', /bayern|bayerisch/i],
      ['Berlin', /berlin/i],
      ['Brandenburg', /brandenburg/i],
      ['Bremen', /bremen/i],
      ['Hamburg', /hamburg/i],
      ['Hessen', /hessen/i],
      ['Mecklenburg-Vorpommern', /mecklenburg/i],
      ['Niedersachsen', /niedersachsen/i],
      ['Nordrhein-Westfalen', /nordrhein|\bnrw\b/i],
      ['Rheinland-Pfalz', /rheinland/i],
      ['Saarland', /saarland/i],
      ['Sachsen', /(^|[^a-zäöüß])sachsen(?!-anhalt)/i],
      ['Sachsen-Anhalt', /sachsen-anhalt/i],
      ['Schleswig-Holstein', /schleswig/i],
      ['Thüringen', /th(ü|ue)ringen/i],
    ];
    const bereich = [
      ['Polizei', /polizei|gsg\s?9|kriminalamt|\blka\b|\bbka\b/i],
      ['Bundespolizei', /bundespolizei|gsg\s?9/i],
      ['Kriminalamt (LKA/BKA)', /kriminalamt|\blka\b|\bbka\b/i],
      ['Zoll', /zoll/i],
      ['Bundeswehr', /bundeswehr/i],
      ['Bundesheer (AT)', /bundesheer/i],
      ['Feuerwehr', /feuerwehr/i],
      ['Justiz & JVA', /justiz|\bjva\b|gerichtsvollzieher|rechtspfleger/i],
      ['Verwaltung', /verwaltung/i],
      ['Finanzamt & Steuer', /finanzamt|steuerfach|finanzverwaltung/i],
      ['Bahn & ÖPNV', /\bbahn\b|lokf(ü|ue)hrer|schiene|\böpnv\b/i],
      ['Medizin & Pflege', /medizin|\btms\b|pflege|notfallsanit|hebamme/i],
    ];
    const preis = [
      ['bis 20 €', (p) => p > 0 && p <= 20],
      ['20–50 €', (p) => p > 20 && p <= 50],
      ['über 50 €', (p) => p > 50],
    ];
    return [
      { key: 'land', label: 'Bundesland', values: land, type: 'title' },
      { key: 'bereich', label: 'Bereich', values: bereich, type: 'title' },
      { key: 'preis', label: 'Preis', values: preis, type: 'price' },
    ];
  }

  _cards() {
    return Array.from(this._list.querySelectorAll('.th-collection-grid__card-wrapper'));
  }

  /** Facetten-Labels einer Karte pro Achse (gecached am Element). */
  _facets(li) {
    if (li._thFacets) return li._thFacets;
    const title = li.getAttribute('data-th-title') || '';
    const price = parseFloat(li.getAttribute('data-th-price') || '0');
    const out = {};
    for (const axis of this._axes) {
      const hits = [];
      for (const [label, test] of axis.values) {
        const match = axis.type === 'price' ? test(price) : test.test(title);
        if (match) hits.push(label);
      }
      out[axis.key] = hits;
    }
    li._thFacets = out;
    return out;
  }

  _render() {
    const cards = this._cards();
    const totalLoaded = cards.length;
    const counts = {};
    for (const axis of this._axes) counts[axis.key] = new Map();
    for (const li of cards) {
      const f = this._facets(li);
      for (const axis of this._axes) {
        for (const label of f[axis.key]) {
          counts[axis.key].set(label, (counts[axis.key].get(label) || 0) + 1);
        }
      }
    }

    this.textContent = '';
    let anyAxis = false;

    const head = document.createElement('div');
    head.className = 'th-cg-filters__head';
    const title = document.createElement('p');
    title.className = 'th-cg-filters__title';
    title.textContent = 'Filter';
    head.appendChild(title);
    if (this._pages > 1 && !this._loaded && !this._loadFailed) {
      const load = document.createElement('span');
      load.className = 'th-cg-filters__loading';
      load.setAttribute('data-th-loading', '');
      head.appendChild(load);
    }
    const reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'th-cg-filters__reset';
    reset.textContent = 'Zurücksetzen';
    reset.hidden = !this._isFiltering();
    reset.addEventListener('click', () => this._reset());
    head.appendChild(reset);
    this._resetBtn = reset;
    this.appendChild(head);

    for (const axis of this._axes) {
      const entries = [];
      for (const [label] of axis.values) {
        const n = counts[axis.key].get(label) || 0;
        const activeSet = this._active[axis.key];
        const isActive = !!(activeSet && activeSet.has(label));
        if (n > 0 && (n < totalLoaded || isActive)) entries.push([label, n, isActive]);
      }
      /* P2-12 (QA 04.09.): eine Achse mit nur einem Wert filtert nichts Sinnvolles
         („Bayern (1)“ auf Sprache) — Filter-Gruppe erst ab 2 Werten. */
      if (entries.length < 2) continue;
      anyAxis = true;

      const group = document.createElement('div');
      group.className = 'th-cg-filters__group';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', 'Nach ' + axis.label + ' filtern');
      const gl = document.createElement('span');
      gl.className = 'th-cg-filters__group-label';
      gl.textContent = axis.label;
      group.appendChild(gl);
      const chips = document.createElement('div');
      chips.className = 'th-cg-filters__chips';
      for (const [label, n, isActive] of entries) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'th-cg-filters__chip';
        b.setAttribute('aria-pressed', String(isActive));
        const t = document.createElement('span');
        t.textContent = label;
        const c = document.createElement('span');
        c.className = 'th-cg-filters__chip-count';
        c.textContent = '(' + n + ')';
        b.appendChild(t);
        b.appendChild(c);
        b.addEventListener('click', () => this._toggle(axis.key, label, b));
        chips.appendChild(b);
      }
      group.appendChild(chips);
      this.appendChild(group);
    }

    this.hidden = !anyAxis;
  }

  _isFiltering() {
    for (const k of Object.keys(this._active)) {
      if (this._active[k] && this._active[k].size) return true;
    }
    return false;
  }

  _toggle(key, label, btn) {
    if (!this._active[key]) this._active[key] = new Set();
    if (this._active[key].has(label)) {
      this._active[key].delete(label);
      btn.setAttribute('aria-pressed', 'false');
    } else {
      this._active[key].add(label);
      btn.setAttribute('aria-pressed', 'true');
    }
    if (this._pages > 1 && !this._loaded && !this._loadFailed) {
      this._ensureLoaded().then(() => this._apply());
    }
    this._apply();
  }

  _reset() {
    this._active = {};
    for (const b of this.querySelectorAll('.th-cg-filters__chip')) {
      b.setAttribute('aria-pressed', 'false');
    }
    this._apply();
  }

  _apply() {
    const filtering = this._isFiltering();
    let shown = 0;
    for (const li of this._cards()) {
      const merged = li.hasAttribute('data-th-merged');
      let visible;
      if (!filtering) {
        visible = !merged;
      } else {
        visible = this._matches(li);
      }
      li.hidden = !visible;
      if (filtering && visible) shown += 1;
    }

    if (this._resetBtn) this._resetBtn.hidden = !filtering;
    if (this._pagEl) this._pagEl.hidden = filtering;
    if (this._emptyEl) this._emptyEl.hidden = !filtering || shown > 0;

    if (this._countEl) {
      if (!filtering) {
        this._countEl.textContent = this._origCount;
      } else if (this._loaded) {
        this._countEl.textContent = shown + ' von ' + this._total + ' Produkten';
      } else {
        this._countEl.textContent = shown + ' Treffer auf dieser Seite';
      }
    }
  }

  _matches(li) {
    const f = this._facets(li);
    for (const axis of this._axes) {
      const set = this._active[axis.key];
      if (!set || !set.size) continue;
      let hit = false;
      for (const label of f[axis.key]) {
        if (set.has(label)) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  /** Laedt alle weiteren Seiten der Collection via Section Rendering API nach. */
  _ensureLoaded() {
    if (this._loaded || this._loadFailed) return Promise.resolve();
    if (this._loadPromise) return this._loadPromise;

    const loadEl = this.querySelector('[data-th-loading]');
    if (loadEl) loadEl.textContent = 'Lade alle Produkte …';

    const jobs = [];
    const maxPages = Math.min(this._pages, 25);
    for (let p = 1; p <= maxPages; p++) {
      if (p === this._currentPage) continue;
      const u = new URL(this.dataset.collectionUrl, window.location.origin);
      const cur = new URLSearchParams(window.location.search);
      if (cur.get('sort_by')) u.searchParams.set('sort_by', cur.get('sort_by'));
      u.searchParams.set('page', String(p));
      u.searchParams.set('section_id', this.dataset.sectionId);
      jobs.push(
        fetch(u.href).then((r) => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text().then((html) => ({ page: p, html }));
        })
      );
    }

    this._loadPromise = Promise.all(jobs)
      .then((results) => {
        const parser = new DOMParser();
        for (const { page, html } of results) {
          const doc = parser.parseFromString(html, 'text/html');
          const lis = doc.querySelectorAll('.th-collection-grid__card-wrapper');
          for (const [i, li] of Array.from(lis).entries()) {
            const node = document.importNode(li, true);
            node.setAttribute('data-th-merged', '');
            node.setAttribute('data-th-page', String(page));
            node.setAttribute('data-th-idx', String(i));
            node.hidden = true;
            this._list.appendChild(node);
          }
        }
        const sorted = this._cards().sort((a, b) => {
          const pa = parseInt(a.getAttribute('data-th-page'), 10);
          const pb = parseInt(b.getAttribute('data-th-page'), 10);
          if (pa !== pb) return pa - pb;
          return parseInt(a.getAttribute('data-th-idx'), 10) - parseInt(b.getAttribute('data-th-idx'), 10);
        });
        for (const li of sorted) this._list.appendChild(li);
        this._loaded = true;
        this._render();
        this._apply();
      })
      .catch((err) => {
        this._loadFailed = true;
        console.warn('[th-collection-filters] Nachladen fehlgeschlagen — Filter wirken nur auf diese Seite.', err);
        this._render();
        this._apply();
      });
    return this._loadPromise;
  }
}
if (!customElements.get('th-collection-filters')) {
  customElements.define('th-collection-filters', ThCollectionFilters);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-demo-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(card) {
    var total = parseInt(card.dataset.total, 10) || 0;
    var score = 0, current = 0, answered = false;
    var questions = card.querySelectorAll('.th-quiz__q');
    var dots = card.querySelectorAll('.th-quiz__progress-dot');

    function show(idx) {
      questions.forEach(function (q, i) { q.hidden = i !== idx; q.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.classList.toggle('is-done', i < idx);
      });
      answered = false;
    }

    card.querySelectorAll('.th-quiz__q').forEach(function (q) {
      var options = q.querySelectorAll('.th-quiz__option');
      var explain = q.querySelector('[data-explain]');
      var resultLabel = q.querySelector('[data-result-label]');
      var head = q.querySelector('.th-quiz__explain-head');

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (answered) return;
          answered = true;
          var isCorrect = opt.dataset.correct === 'true';
          if (isCorrect) score++;
          opt.classList.add(isCorrect ? 'is-correct' : 'is-wrong');
          options.forEach(function (o) {
            o.disabled = true;
            if (o.dataset.correct === 'true') o.classList.add('is-correct');
          });
          if (head) head.classList.add(isCorrect ? 'is-correct' : 'is-wrong');
          if (resultLabel) resultLabel.textContent = isCorrect ? 'Richtig! ✓' : 'Leider falsch, so geht’s richtig:';
          if (explain) explain.hidden = false;
        });
      });

      var next = q.querySelector('[data-quiz-next]');
      if (next) next.addEventListener('click', function () {
        if (current < total - 1) { current++; show(current); }
        else {
          questions.forEach(function (qq) { qq.hidden = true; });
          dots.forEach(function (d) { d.classList.remove('is-active'); d.classList.add('is-done'); });
          var result = card.querySelector('[data-quiz-result]');
          if (result) { result.hidden = false; var s = result.querySelector('[data-score]'); if (s) s.textContent = score; }
        }
      });
    });
  }
  function init() { document.querySelectorAll('[data-th-quiz-card]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-footer"] && !Shopify.designMode) return;
  try {
    
  // Footer column accordions: collapsed on mobile, forced open (non-interactive) on desktop.
  // Progressive enhancement — without JS every column simply stays open.
  (() => {
    const details = document.querySelectorAll('.th-footer__col-details');
    if (details.length === 0) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const apply = () => {
      for (const d of details) {
        d.open = !mq.matches;
        const summary = d.querySelector('summary');
        if (summary) summary.tabIndex = mq.matches ? 0 : -1;
      }
    };
    apply();
    mq.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-leaderboard"] && !Shopify.designMode) return;
  try {
    
/* th-leaderboard — animated Puls counters (IntersectionObserver, reduced-motion aware).
   The 7d/30d switch is pure CSS (:has + native radios); no JS needed for it. */
(function () {
  var nf = new Intl.NumberFormat('de-DE');

  function animate(el) {
    var target = parseInt(el.getAttribute('data-th-count'), 10);
    if (isNaN(target)) return;
    var dur = target > 100000 ? 1600 : 1200;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = nf.format(Math.round(eased * target));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Scroll-Affordance der Tabelle: Fade rechts nur, solange rechts noch Spalten liegen. */
  function initTableShadows() {
    var shells = document.querySelectorAll('[data-th-lb-shell]');
    shells.forEach(function (shell) {
      var wrap = shell.querySelector('[data-th-lb-tablewrap]');
      if (!wrap) return;
      function update() {
        var scrollable = wrap.scrollWidth > wrap.clientWidth + 1;
        var atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 1;
        shell.toggleAttribute('data-scrollable', scrollable);
        shell.toggleAttribute('data-at-end', atEnd);
      }
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      // 7d-Board ist beim Load display:none (clientWidth 0) → nach dem
      // CSS-only-Umschalten neu messen.
      var boards = shell.closest('[data-th-lb-switch]');
      if (boards) {
        boards.querySelectorAll('.th-lb__switch-input').forEach(function (input) {
          input.addEventListener('change', function () { requestAnimationFrame(update); });
        });
      }
    });
  }

  function init() {
    initTableShadows();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scopes = document.querySelectorAll('[data-th-count-scope]');
    scopes.forEach(function (scope) {
      var nums = scope.querySelectorAll('[data-th-count]');
      if (reduce || !('IntersectionObserver' in window)) {
        nums.forEach(function (el) {
          var t = parseInt(el.getAttribute('data-th-count'), 10);
          if (!isNaN(t)) el.textContent = nf.format(t);
        });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            nums.forEach(animate);
            io.unobserve(scope);
          }
        });
      }, { threshold: 0.25 });
      io.observe(scope);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-live-feed"] && !Shopify.designMode) return;
  try {
    
/* th-live-feed — gentle auto-scroll ticker. Pauses on hover/focus; static when
   the user prefers reduced motion or the list already fits. Relative time is
   handled by the shared th-feed-item script. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(scroller) {
    if (scroller.dataset.thFeedBound) return;
    scroller.dataset.thFeedBound = '1';
    if (reduce) return;
    if (scroller.scrollHeight - scroller.clientHeight < 24) return;

    var paused = false;
    var userPaused = false;
    var acc = 0;
    var last = null;
    var pauseUntil = 0;
    var SPEED = 18; // px per second

    var pause = function () { paused = true; };
    var resume = function () { paused = false; };
    scroller.addEventListener('pointerenter', pause);
    scroller.addEventListener('pointerleave', resume);
    scroller.addEventListener('focusin', pause);
    scroller.addEventListener('focusout', resume);
    scroller.addEventListener('touchstart', pause, { passive: true });

    // WCAG 2.2.2: explicit, visible pause control (only shown when the ticker runs)
    var card = scroller.closest('.th-live-feed__card');
    var pauseBtn = card ? card.querySelector('[data-th-feed-pause]') : null;
    if (pauseBtn) {
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.setAttribute(
          'aria-label',
          userPaused ? 'Automatisches Weiterscrollen fortsetzen' : 'Automatisches Weiterscrollen pausieren'
        );
        var txt = pauseBtn.querySelector('[data-th-feed-pause-text]');
        if (txt) txt.textContent = userPaused ? 'Weiter' : 'Pause';
      });
    }

    function frame(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;

      if (!paused && !userPaused && ts >= pauseUntil) {
        acc += SPEED * dt;
        var whole = Math.floor(acc);
        if (whole >= 1) {
          acc -= whole;
          var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
          if (atBottom) {
            pauseUntil = ts + 1400;      // dwell at the end
            scroller.scrollTop = 0;      // loop back to newest
          } else {
            scroller.scrollTop += whole;
          }
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init() {
    var list = document.querySelectorAll('[data-th-feed-scroll]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-pain-chat"] && !Shopify.designMode) return;
  try {
    
/* th-pain-chat — staggered reveal of chat bubbles on scroll.
   Progressive enhancement: without JS (or with reduced motion) everything is
   visible immediately; the hiding class is only added when the observer runs. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var sections = document.querySelectorAll('[data-th-pain]');
    if (!sections.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    sections.forEach(function (sec) {
      if (sec.dataset.thPainBound) return;
      sec.dataset.thPainBound = '1';
      sec.classList.add('th-pain--js');

      var bubbles = sec.querySelectorAll('[data-th-pain-bubble]');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var idx = Array.prototype.indexOf.call(bubbles, el);
            el.style.transitionDelay = Math.min(idx * 130, 520) + 'ms';
            el.classList.add('is-in');
            io.unobserve(el);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
      );
      bubbles.forEach(function (b) { io.observe(b); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-pricing-table"] && !Shopify.designMode) return;
  try {
    
/**
 * Paket-Tabelle: das mobil eingeklappte <details> automatisch oeffnen, wenn
 * der Sprunglink #th-paketvergleich (Buy-Box-Picker) geklickt wird, der Hash
 * beim Laden/Wechsel gesetzt ist oder der Viewport auf Desktop wechselt
 * (dort ist der Toggle ausgeblendet und die Tabelle immer offen).
 */
(() => {
  const OPEN_HASH = '#th-paketvergleich';

  const openAll = () => {
    for (const details of document.querySelectorAll('[data-th-pt-details]')) {
      details.open = true;
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href*="#th-paketvergleich"]');
    if (link) openAll();
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash === OPEN_HASH) openAll();
  });

  if (window.location.hash === OPEN_HASH) openAll();

  const desktop = window.matchMedia('(min-width: 750px)');
  const syncViewport = () => {
    if (desktop.matches) openAll();
  };
  desktop.addEventListener('change', syncViewport);
  syncViewport();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-product-description"] && !Shopify.designMode) return;
  try {
    
/**
 * D2.2 — macht migrierte Elementor-Akkordeons in der Produktbeschreibung
 * klappbar (kompakt/scanbar). Ohne JS bleiben alle Inhalte statisch sichtbar
 * (kein Content-Verlust). Erster Eintrag startet geoeffnet.
 */
(() => {
  document.querySelectorAll('.th-product-description__body').forEach((body, bodyIndex) => {
    const items = body.querySelectorAll('.elementor-accordion-item');
    if (!items.length) return;
    body.classList.add('th-desc-acc');

    items.forEach((item, i) => {
      const title = item.querySelector('.elementor-tab-title');
      const content = item.querySelector('.elementor-tab-content');
      if (!title || !content) return;

      if (!content.id) content.id = `th-desc-acc-${bodyIndex}-${i}`;
      const startOpen = i === 0;

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', content.id);
      title.setAttribute('aria-expanded', String(startOpen));
      content.hidden = !startOpen;

      const icon = document.createElement('span');
      icon.className = 'th-desc-acc__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';
      title.appendChild(icon);

      const toggle = () => {
        const willOpen = content.hidden;
        content.hidden = !willOpen;
        title.setAttribute('aria-expanded', String(willOpen));
      };

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          toggle();
        }
      });
    });
  });
})();

/**
 * D2 (QA 04.09.) — „Mehr lesen": Beschreibungen ueber ~1.200 px Hoehe werden
 * eingeklappt (Zoll-PDP: 6.900 px). Laeuft NACH dem Akkordeon-Setup oben, damit
 * die Messung die eingeklappten Akkordeons beruecksichtigt. Der Text bleibt im
 * DOM; Fokus in den verdeckten Teil (Tab, Sprunglink) klappt automatisch auf.
 */
(() => {
  const LIMIT = 1200;
  const SLACK = 240; // unter 1.440 px lohnt kein Toggle (sonst 2 Zeilen hinter dem Button)

  document.querySelectorAll('[data-th-desc-body]').forEach((body) => {
    const toggle = body.parentElement.querySelector('[data-th-desc-toggle]');
    if (!toggle) return;
    const label = toggle.querySelector('[data-th-desc-label]');
    let armed = false;
    let open = true;

    const setOpen = (next) => {
      open = next;
      body.classList.toggle('is-collapsed', !next);
      toggle.setAttribute('aria-expanded', String(next));
      if (label) label.textContent = next ? 'Weniger anzeigen' : 'Mehr lesen';
    };

    const arm = () => {
      if (armed || body.scrollHeight <= LIMIT + SLACK) return;
      armed = true;
      toggle.hidden = false;
      setOpen(false);

      toggle.addEventListener('click', () => {
        const closing = open;
        setOpen(!open);
        if (closing) {
          // Nach dem Einklappen (bis zu ~5.500 px weniger Hoehe) zurueck an den
          // Anfang des Textes springen — instant, sonst haengt der Leser im Nichts.
          const top = body.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        }
      });

      // Tastatur/Sprunglink in den abgeschnittenen Teil: aufklappen statt unsichtbar fokussieren
      body.addEventListener('focusin', () => {
        if (!open) setOpen(true);
      });
    };

    arm();
    // Bilder ohne Maße laden spaeter nach -> Hoehe nochmal pruefen
    window.addEventListener('load', arm, { once: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-product-info"] && !Shopify.designMode) return;
  try {
    
/**
 * th-variant-picker — enhances the native-radio buy form.
 * Without JS the radios still post the right variant id to /cart/add.
 */
class ThVariantPicker extends HTMLElement {
  connectedCallback() {
    this._sectionId = this.dataset.sectionId;
    this._form = this.querySelector('[data-atc-form]');
    this._priceEl = document.getElementById('th-price-' + this._sectionId);

    // "Alle Details vergleichen" nur zeigen, wenn die Vergleichstabelle
    // (th-pricing-table, Anker #th-paketvergleich) auf dem Template existiert.
    const compareLink = this.querySelector('[data-compare-link]');
    if (compareLink && !document.getElementById('th-paketvergleich')) {
      compareLink.hidden = true;
    }

    this.querySelectorAll('.th-product-info__variant-input').forEach((input) => {
      input.addEventListener('change', this._onVariantChange.bind(this));
    });
    if (this._form) this._form.addEventListener('submit', this._onSubmit.bind(this));
    this._bindGallery();
  }

  _root() {
    return this.closest('.shopify-section') || this.closest('.th-product-info') || document;
  }

  /* Scroll-Snap-Galerie: Thumbs (Desktop) + Dots (mobil) scrollen zum Slide,
     Wischen/Scrollen synct den aktiven Zustand zurück. */
  _bindGallery() {
    const root = this._root();
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
    if (!thumbs.length && !dots.length) return;

    const goTo = (index) => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: index * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    };
    thumbs.forEach((btn, i) => btn.addEventListener('click', () => goTo(i)));
    dots.forEach((btn, i) => btn.addEventListener('click', () => goTo(i)));

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach((b, i) => {
          b.classList.toggle('th-product-info__thumb--active', i === index);
          b.setAttribute('aria-pressed', String(i === index));
        });
        dots.forEach((b, i) => {
          b.classList.toggle('is-active', i === index);
          if (i === index) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      });
    }, { passive: true });
  }

  _onVariantChange(evt) {
    const input = evt.currentTarget;
    const card = input.closest('.th-product-info__variant-card');

    this.querySelectorAll('.th-product-info__variant-card').forEach((c) => {
      c.classList.toggle('is-selected', c === card);
    });

    // Price + savings
    if (this._priceEl) {
      const amount = this._priceEl.querySelector('.th-product-info__price-amount');
      if (amount) amount.textContent = input.dataset.variantPrice;

      const compare = this._priceEl.querySelector('[data-price-compare]');
      if (compare) {
        if (input.dataset.variantCompare) {
          compare.innerHTML = '<s>' + input.dataset.variantCompare + '</s>';
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
      const save = this._priceEl.querySelector('[data-price-save]');
      if (save) {
        if (input.dataset.variantCompare && input.dataset.variantSaved) {
          save.textContent = 'Du sparst ' + input.dataset.variantSaved;
          save.hidden = false;
        } else {
          save.hidden = true;
        }
      }

      // Preis-Reframing-Zeile an die Preisstufe des gewählten Pakets anpassen
      const reframe = this._priceEl.parentElement.querySelector('[data-price-reframe]');
      if (reframe) {
        const cents = parseInt(input.dataset.variantPriceCents, 10);
        if (!isNaN(cents)) {
          reframe.textContent = cents < 9000 ? reframe.dataset.reframeLow : reframe.dataset.reframeHigh;
        }
      }

      // Versandhinweis: nur bei versandpflichtigen Varianten. 7 Produkte sind
      // gemischt (Komplettpakete digital, Premiumpaket versandpflichtig),
      // deshalb muss die Zeile beim Paketwechsel mitschalten.
      const shippingNote = this._priceEl.parentElement.querySelector('[data-shipping-note]');
      if (shippingNote) {
        shippingNote.hidden = input.dataset.variantShipping !== 'true';
      }
    }

    // ATC availability
    const atcBtn = this._form && this._form.querySelector('.th-product-info__atc-button');
    if (atcBtn) {
      const available = input.dataset.variantAvailable !== 'false';
      atcBtn.disabled = !available;
      atcBtn.setAttribute('aria-disabled', String(!available));
      const label = atcBtn.querySelector('.th-product-info__atc-label');
      if (label) label.textContent = available ? 'In den Warenkorb' : 'Aktuell nicht verfügbar';
    }

    // 6h: SR-Ankündigung des Paketwechsels (clear -> rAF-set, damit aria-live
    // auch bei gleichbleibender Struktur zuverlässig feuert)
    const announceRegion = this.querySelector('[data-variant-announce-region]');
    if (announceRegion) {
      const msg = input.dataset.variantAnnounce || '';
      announceRegion.textContent = '';
      requestAnimationFrame(() => {
        announceRegion.textContent = msg;
      });
    }

    // 6h: Klick-Mikrofeedback — Highlight-Puls auf der frisch expandierten
    // Liste neu anstoßen (reduced motion: CSS setzt animation: none)
    const freshDetails = card ? card.querySelector('[data-variant-details]') : null;
    if (freshDetails) {
      freshDetails.classList.remove('is-fresh');
      void freshDetails.offsetWidth; // Reflow erzwingen -> Animation startet neu
      freshDetails.classList.add('is-fresh');
    }
  }

  async _onSubmit(evt) {
    evt.preventDefault();
    const btn = this._form.querySelector('.th-product-info__atc-button');
    if (!btn || btn.disabled) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    try {
      const formData = new FormData(this._form);

      // Ask /cart/add to also render the cart-drawer section(s) so we can update the
      // slide-out overlay in place — no navigation to the /cart page.
      const sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
        const id = el.getAttribute('data-section-id');
        if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
      });
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      const res = await fetch(this._form.action, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Cart error');
      }

      this._openCartOverlay(data);
      return;
    } catch (err) {
      console.error('[th-product-info] ATC error:', err);
      this._form.submit(); // fall back to native cart add / full navigation
      return;
    } finally {
      btn.setAttribute('aria-busy', 'false');
      btn.disabled = false;
    }
  }

  /**
   * Updates the cart bubble + drawer contents and slides the cart overlay open.
   * Reuses the header's Horizon cart-drawer-component (same drawer as the cart icon),
   * so the §356 consent checkbox + gated checkout stay intact.
   * @param {object} data - The /cart/add JSON response (added line item + sections).
   */
  _openCartOverlay(data) {
    const variantInput = this._form.querySelector('input[name="id"]');

    // CartAddEvent.eventName === 'cart:update'. cart-items-component morphs the drawer
    // from data.sections; the cart bubble + totals update; cart-consent (§356) survives.
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: this._sectionId || 'th-product-info',
          data: {
            source: 'th-product-info',
            productId: this.dataset.productHandle,
            variantId: variantInput ? variantInput.value : undefined,
            sections: data.sections,
          },
        },
      })
    );

    // No drawer in the DOM (cart_type !== 'drawer') → fall back to the cart page.
    if (!document.querySelector('cart-drawer-component')) {
      window.location.href = '/cart';
      return;
    }

    // auto_open_cart_drawer defaults to off, so open the drawer explicitly. The element
    // is loaded as a module (may not be upgraded yet) → wait for it, then open.
    const atcButton = this._form.querySelector('.th-product-info__atc-button');
    const openIt = () => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        // Focus fell to <body> while the ATC button was disabled during the fetch —
        // tell the drawer where focus belongs once it closes (Escape / close button).
        drawer.returnFocusTo = atcButton;
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    };
    if (window.customElements && customElements.get('cart-drawer-component')) {
      openIt();
    } else if (window.customElements) {
      customElements.whenDefined('cart-drawer-component').then(openIt);
    } else {
      window.location.href = '/cart';
    }
  }
}
if (!customElements.get('th-variant-picker')) {
  customElements.define('th-variant-picker', ThVariantPicker);
}

/* Mobile sticky ATC: reveal when the main button scrolls off-screen */
(function setupStickyAtc() {
  if (typeof IntersectionObserver === 'undefined') return;
  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach((sticky) => {
      const sectionId = sticky.dataset.sectionId;
      const mainForm = document.querySelector('.th-product-info[data-section-id="' + sectionId + '"] .th-product-info__atc-form');
      if (!mainForm) return;
      const stickyBtn = sticky.querySelector('[data-sticky-atc-button]');
      const stickyPrice = sticky.querySelector('[data-sticky-price]');

      // Observe the CTA BUTTON itself (not the whole form): the bar appears only
      // once the button has scrolled OUT ABOVE the viewport (user passed the CTA).
      // Observing the form made the bar show at y=0 (form bottom below the fold)
      // and hide mid-page even though the CTA was long gone.
      // QA-UX 12.10. (Opus P2-4): Ein IntersectionObserver allein reicht nicht —
      // nach einem Sprung nach oben (Pos1, scrollTo(0), Anker) ist der CTA weiter
      // NICHT im Viewport (er liegt unter dem Fold), der Schnittzustand ändert sich
      // nicht, der Callback feuert nicht und die Leiste blieb über der Paketliste.
      // Entscheidung deshalb immer über die Lage des Buttons (bottom < 0), geprüft
      // bei jedem Scroll/Resize (rAF-gedrosselt) und zusätzlich im Observer.
      const ctaBtn = mainForm.querySelector('.th-product-info__atc-button') || mainForm;
      const update = () => {
        const show = ctaBtn.getBoundingClientRect().bottom < 0;
        sticky.removeAttribute('hidden');
        sticky.setAttribute('data-visible', show ? 'true' : 'false');
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; update(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      new IntersectionObserver(update, { threshold: 0 }).observe(ctaBtn);
      update();

      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          const submitBtn = mainForm.querySelector('.th-product-info__atc-button');
          if (submitBtn && !submitBtn.disabled) submitBtn.click();
        });
      }

      const priceEl = document.getElementById('th-price-' + sectionId);
      if (priceEl && stickyPrice) {
        new MutationObserver(() => {
          const amount = priceEl.querySelector('.th-product-info__price-amount');
          if (amount) stickyPrice.textContent = amount.textContent;
        }).observe(priceEl, { subtree: true, childList: true, characterData: true });
      }

      const atcBtn = mainForm.querySelector('.th-product-info__atc-button');
      if (atcBtn && stickyBtn) {
        new MutationObserver(() => {
          stickyBtn.disabled = atcBtn.disabled;
          stickyBtn.setAttribute('aria-disabled', String(atcBtn.disabled));
          stickyBtn.textContent = atcBtn.disabled ? 'Nicht verfügbar' : 'In den Warenkorb';
        }).observe(atcBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Live-Zeile (D1.4): sanft durch die echten Botschaften rotieren (Plattform-
   Puls + Live-Feed-Ereignisse). Ohne JS oder mit reduced motion bleibt die
   erste Botschaft (Puls) statisch stehen — kein Inhalt geht verloren. */
(function setupLiveLineRotation() {
  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-live-rotate]').forEach((track) => {
      const msgs = track.querySelectorAll('.th-live-line__msg');
      if (msgs.length < 2) return;
      let idx = 0;
      setInterval(() => {
        idx = (idx + 1) % msgs.length;
        msgs.forEach((m, i) => {
          m.classList.toggle('is-active', i === idx);
          // Der Puls (Index 0) traegt das aria-Label der Zeile; Feed-Botschaften
          // bleiben fuer SR dauerhaft aria-hidden (kein Live-Region-Geplapper).
          if (i > 0) m.setAttribute('aria-hidden', 'true');
        });
      }, 6000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-sample-questions"] && !Shopify.designMode) return;
  try {
    
/**
 * th-sample-question — enhances one real sample question card.
 * Without JS the options are inert, but the native <details> ("Lösung anzeigen")
 * still reveals the correct answer + explanation.
 */
class ThSampleQuestion extends HTMLElement {
  connectedCallback() {
    this._correct = parseInt(this.dataset.correct, 10);
    this._feedback = this.querySelector('[data-feedback]');
    this._solution = this.querySelector('[data-solution]');
    this._buttons = Array.from(this.querySelectorAll('[data-opt]'));
    for (const btn of this._buttons) {
      btn.addEventListener('click', this._onPick.bind(this));
    }
  }

  _onPick(evt) {
    const btn = evt.currentTarget;
    const idx = parseInt(btn.dataset.opt, 10);
    const isCorrect = idx === this._correct;
    const letters = 'ABCDEF';

    for (const b of this._buttons) {
      const i = parseInt(b.dataset.opt, 10);
      b.classList.toggle('is-chosen', b === btn);
      b.classList.toggle('is-correct', i === this._correct);
      b.classList.toggle('is-wrong', b === btn && !isCorrect);
      b.setAttribute('aria-pressed', String(b === btn));
    }
    this.classList.add('is-answered');

    if (this._feedback) {
      this._feedback.textContent = isCorrect
        ? 'Richtig! Genau solche Fragen übst du im Testtrainer.'
        : 'Leider falsch, richtig ist Antwort ' + letters.charAt(this._correct) + '.';
      this._feedback.classList.toggle('is-good', isCorrect);
      this._feedback.classList.toggle('is-bad', !isCorrect);
    }
    if (this._solution && !this._solution.open) {
      this._solution.open = true;
    }
  }
}
if (!customElements.get('th-sample-question')) {
  customElements.define('th-sample-question', ThSampleQuestion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-sport-trainer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    if (!('IntersectionObserver' in window)) { document.querySelectorAll('[data-th-sport]').forEach(function(s){s.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    document.querySelectorAll('[data-th-sport]').forEach(function (s) { io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
